//import "./bootstrap";
import Vue from 'vue';

import App from './App.vue';
import store from './store';
import router from './router';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: -70,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

import VModal from 'vue-js-modal'
Vue.use(VModal)

axios.defaults.baseURL = 'https://api.piachu.net/';
import utils from './mixins/util';
Vue.mixin(utils);
Vue.config.productionTip = false

if (localStorage.getItem('piachu')) {
  const strageData = JSON.parse(localStorage.getItem('piachu'));
  if (strageData.auth.token) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + strageData.auth.token;
  }
}

const retryAuthAxios = axios.create()
axios.interceptors.response.use(
    response => {
      return response
    },
    error => {
        localStorage.setItem("beforeUrl", location.pathname);
        if (error.response && error.response.config && error.response.status === 401) { //, {}, { headers: { 'X-CSRF-TOKEN': localStorage.csrf } }
            retryAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.auth.token;
            retryAuthAxios.get('/api/refresh')
            .then(response => {
                const token = {};
                token["access_token"] = response.data.access_token;
                token["users_id"] = response.data.users_id;
                token["user_type"] = response.data.user_type;
                token["identification_flg"] = response.data.identification_flg;
                let retryConfig = error.response.config
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token["access_token"];
                store.commit('auth/login', token);
                retryConfig.headers['Authorization'] = 'Bearer ' + token["access_token"];
                retryAuthAxios.request(retryConfig) // retryConfig.headers['X-CSRF-TOKEN'] = localStorage.csrf
                .then(response => {
                    return response;
                }).catch(error => {
                    return Promise.reject(error)
                })
            }).catch(error => {
                store.dispatch('auth/auth_error_logout');
                return Promise.reject(error)
            })
        } else {
            return Promise.reject(error)
        }
    }
)

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// カスタムのcss
import css from './assets/css/styles.css'
// import custom_app_css from '../static/css/custom_app.css'

// import { library } from '@fortawesome/fontawesome-svg-core'
// import { fas } from '@fortawesome/free-solid-svg-icons'
// import { fab } from '@fortawesome/free-brands-svg-icons'
// import { far } from '@fortawesome/free-regular-svg-icons'
// library.add(faCoffee)
// library.add(fas, far, fab)
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  el: '#app',
  router,
  store,
  css,
//   custom_app_css,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js